import type { WorkflowType } from '@this/domain/organization/organization2';
import React from 'react';
import {
  SubSection,
  SubSectionTitle
} from '@this/components/organization/setting/workflow_setting_section/shared';
import WorkflowSection from '@this/components/organization/setting/workflow_setting_section/workflow_section';

interface ForeignFlightSectionProps {
  foreignFlightWorkflowType: WorkflowType;
  foreignFlightBufferAmount: number;
  handleChangeWorkflowType: (type: WorkflowType, target: string) => void;
  handleChangeBufferAmount: (amount: number, target: string) => void;
}

const ForeignFlightSection: React.FC<ForeignFlightSectionProps> = ({
  foreignFlightWorkflowType,
  foreignFlightBufferAmount,
  handleChangeWorkflowType,
  handleChangeBufferAmount
}) => {
  return (
    <SubSection>
      <SubSectionTitle>海外航空券</SubSectionTitle>

      <WorkflowSection
        description=""
        itemLabel="航空券"
        workflowType={foreignFlightWorkflowType}
        bufferAmount={foreignFlightBufferAmount}
        target="foreignFlight"
        onChangeWorkflowType={handleChangeWorkflowType}
        onChangeBufferAmount={handleChangeBufferAmount}
      />
    </SubSection>
  );
};

export default ForeignFlightSection;
